import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { SelectedFilter } from './selectedFilter';

@Component({
    selector: 'bg-dropdown',
    templateUrl: './dropdown.component.html',
    imports: [CommonModule, SelectedFilter],
})
export class DropdownComponent implements OnInit, OnChanges {
    @Input() items: { key: string; value: string }[];
    @Input() selectedItemKey: string;
    @Output() onItemClick = new EventEmitter<string>();
    @Output() onDropdownClicked = new EventEmitter();

    public selectedItem: { key: string; value: string };
    public isOpen = false;

    ngOnInit() {
        this.selectedItem = this.items.filter((item) => item.key === this.selectedItemKey)[0] || this.items[0];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.selectedItem || changes.selectedItemKey.currentValue !== this.selectedItem.key) {
            this.selectedItem = this.items.filter((item) => item.key === changes.selectedItemKey.currentValue)[0] || this.items[0];
        }
    }

    constructor(private eRef: ElementRef) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }

    public handleItemClick(item: { key: string; value: string }) {
        this.selectedItem = item;
        this.isOpen = false;
        this.onItemClick.emit(item.key);
    }

    public handleDropdownClick() {
        this.isOpen = !this.isOpen;
        this.onDropdownClicked.emit();
    }
}
